import axios from 'axios'; // 引入axios
import { Notify } from 'vant';
import md5 from 'js-md5';
import config from '@/config';

let gtInstance = axios.create({
  baseURL: config.API_URL
});

gtInstance.defaults.timeout = 10000; // 设置默认的请求超时时间。例如超过了10s，就会告知用户当前请求超时，请刷新等。

// 请求拦截器
gtInstance.interceptors.request.use(
  (config) => {
    // if (token.getToken() !== undefined && token.getToken() !== null) {
    //   config.headers['Authorization'] = token.getToken();
    // }
    // console.log(config);
    config.headers['Authorization'] = 'Bearer ' + md5('abcdefghijklmnopqrstuvwxyz');

    return config; // 对config处理完后返回，下一步将向后端发送请求
  },
  (error) => {
    // 当发生错误时，执行该部分代码
    console.log('request error');
    console.log(error); //调试用
    return Promise.reject(error);
  }
);

// 响应拦截器
gtInstance.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    return Promise.resolve(response);
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  (error) => {
    if (error.response.status) {
      Notify({ message: error.response.data.msg, type: 'danger' });
      return Promise.reject(error.response);
    }
  }
);

export function get(url, params) {
  // get封装
  return new Promise((resolve, reject) => {
    gtInstance
      .get(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function post(url, data) {
  // post封装
  return new Promise((resolve, reject) => {
    gtInstance({
      url: url,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function mediaPost(url, data) {
  // post封装
  return new Promise((resolve, reject) => {
    gtInstance({
      url: url,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function pubPost(url, data) {
  // post封装
  return new Promise((resolve, reject) => {
    gtInstance({
      url: url,
      method: 'POST',
      data: data
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
export default gtInstance;
